import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {setPagerStatePayments as setPagerState, setPeriodState} from "redux/features/customer";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import ExportFileExcel from "./exportFileExcel";
import ResetFilter from "components/resetFilter";
import "./header.scss";
import {formatDateByLanguage, formatDateTimeByLanguage, useCustomLocalization} from "utils";

import defaultMessages from 'i18n/en.json';
import {useInternationalization} from "@progress/kendo-react-intl";

const useLocalizedMessages = () => {
  const [toLanguageString] = useCustomLocalization();
  return {
    initialValuesDropdown: toLanguageString(
      'metislab.frontend.components.customer.components.details.tabs.tabPayments.initialValuesDropdown',
      defaultMessages.metislab.frontend.components.customer.components.details.tabs.tabPayments.initialValuesDropdown),
    periodAll: toLanguageString(
        'metislab.frontend.components.customer.components.details.tabs.tabPayments.periodAll',
        defaultMessages.metislab.frontend.components.customer.components.details.tabs.tabPayments.periodAll),
    periodActual: toLanguageString(
        'metislab.frontend.components.customer.components.details.tabs.tabPayments.periodActual',
        defaultMessages.metislab.frontend.components.customer.components.details.tabs.tabPayments.periodActual),
    periodPast: toLanguageString(
        'metislab.frontend.components.customer.components.details.tabs.tabPayments.periodPast',
        defaultMessages.metislab.frontend.components.customer.components.details.tabs.tabPayments.periodPast),
    lastUpdateDate: toLanguageString(
      'metislab.frontend.components.customer.components.details.tabs.tabPayments.lastUpdateDate',
      defaultMessages.metislab.frontend.components.customer.components.details.tabs.tabPayments.lastUpdateDate),
  };
}

const HeaderCustomerPayments = ({id, isExtended}) => {
  
  const {
    initialValuesDropdown,
    lastUpdateDate,
      periodActual,
      periodAll,
      periodPast

  } = useLocalizedMessages();

  const INITIAL_VALUES_DROPDOWN = {
    label: initialValuesDropdown,
    value: null,
  };
  const INITIAL_VALUES_DROPDOWN_PERIOD = {
    label: periodAll,
    value: 'all',
  };

  const dispatch = useDispatch();

  const layoutColumn = useSelector((state) => state.customer.layoutColumnPayments);
  const pagerState = useSelector((state) => state.customer.pagerStatePayments);
  const periodState = useSelector((state) => state.customer.periodState);
  const lastUpdate = useSelector((state) => state.customer.lastUpdate);

  /**
   * onChangeType is used to handle the dropdown
   * @param {*} e
   */
  const onChangeType = (e) => {
    const value = e.value === INITIAL_VALUES_DROPDOWN
        ? null
        : { label: e.value.label, value: e.value.value };

    dispatch( setPagerState({
        search: value,
        searchBy: 'document_type',
      })
    );
  };
  /**
   * onChangePeriod is used to handle the dropdown
   * @param {*} e
   */
  const onChangePeriod = (e) => {
    const value = e.value === INITIAL_VALUES_DROPDOWN_PERIOD
        ? 'all'
        :  e.value.value ;

    dispatch( setPeriodState({
        period: value,
      })
    );
  };

  const handleResetFilter = () => {
    dispatch(
      setPagerState({
        ...pagerState,
        search: null,
        searchBy: null,
      })
    );
    dispatch(
      setPeriodState({
        period: 'all'
      })
    );
  }

  const intl = useInternationalization();

  const documentTypes = layoutColumn && layoutColumn.filter( column => column.propId === 'document_type')[0].editor.data.rows;

  const periodTypes = [
    {value: 'all', label: periodAll },
    {value: 'actual', label: periodActual },
    {value: 'past', label: periodPast },
  ]

  return (
    <header className="c-subheader l-desktop-flex k-align-items-center k-justify-content-end">
      <ul
        className="c-subheader__filter l-tablet-flex k-align-items-center"
        style={{ listStyle: "none" }}
      >
        {isExtended && lastUpdate &&  <li>
          <label>{lastUpdateDate}:  { formatDateTimeByLanguage(
              intl.locale,
                new Date(lastUpdate)
            )} </label>
        </li>}
        <li>
          <ExportFileExcel id={id} isExtended={isExtended}/>
        </li>
        {(pagerState?.search || pagerState?.searchBy) && (
          <li>
            <ResetFilter
              dispatchResetAction={handleResetFilter}
            />
          </li>
        )}
        {!isExtended && <li className="c-filter">
          <DropDownList
            className="c-filter-container"
            name="searchByType"
            data={documentTypes || []}
            fillMode="outline"
            textField="label"
            dataItemKey="value"
            defaultItem={INITIAL_VALUES_DROPDOWN}
            onChange={onChangeType}
            value={pagerState.search}
            popupSettings={{ popupClass: "c-filter-content", width: 180 }}
          />
        </li>}
        {isExtended && <li className="c-filter">
          <DropDownList
            className="c-filter-container"
            name="searchByPeriod"
            data={periodTypes || []}
            fillMode="outline"
            textField="label"
            dataItemKey="value"
            defaultItem={INITIAL_VALUES_DROPDOWN_PERIOD}
            onChange={onChangePeriod}
            value={ periodState?.period ? periodTypes.find(el => el.value=== periodState.period) ?? INITIAL_VALUES_DROPDOWN_PERIOD : INITIAL_VALUES_DROPDOWN_PERIOD}
            popupSettings={{ popupClass: "c-filter-content", width: 180 }}
          />
        </li>}
      </ul>
    </header>
  );
};

export default HeaderCustomerPayments;
